var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"modify",class:{ disabled: _vm.canNotModified },on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.modifyOrder.apply(null, arguments)}}},[_c('icon',{attrs:{"name":"modify"}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('trade.orders.modification')))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }